export default "__VITE_ASSET__C4oTx9lL__"